import { render, staticRenderFns } from "./i-have-examine.vue?vue&type=template&id=04ed3bae"
import script from "./i-have-examine.vue?vue&type=script&lang=js"
export * from "./i-have-examine.vue?vue&type=script&lang=js"
import style0 from "./i-have-examine.vue?vue&type=style&index=0&id=04ed3bae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports